import { render, staticRenderFns } from "./AppShowPhones.vue?vue&type=template&id=3a45826a&"
import script from "./AppShowPhones.vue?vue&type=script&lang=js&"
export * from "./AppShowPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports